import { render, staticRenderFns } from "./TenantIncome.vue?vue&type=template&id=41bfb22a"
import script from "./TenantIncome.vue?vue&type=script&lang=js"
export * from "./TenantIncome.vue?vue&type=script&lang=js"
import style0 from "./TenantIncome.vue?vue&type=style&index=0&id=41bfb22a&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports